import { render, staticRenderFns } from "./OtherResourceDownload.vue?vue&type=template&id=3dbd4280&scoped=true"
import script from "./OtherResourceDownload.vue?vue&type=script&lang=js"
export * from "./OtherResourceDownload.vue?vue&type=script&lang=js"
import style0 from "./OtherResourceDownload.vue?vue&type=style&index=0&id=3dbd4280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd4280",
  null
  
)

export default component.exports